import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { ThemeProvider } from "./glassTheme.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode><ThemeProvider><App /></ThemeProvider></StrictMode>
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
}
